import DeliveryBoxIcon from "./svg/16/DeliveryBoxIcon";
import ThicknessIcon from "./svg/16/ThicknessIcon";
import YarnIcon from "./svg/16/YarnIcon";
import FacebookIcon from "./svg/24/FacebookIcon";
import InstagramIcon from "./svg/24/InstagramIcon";
import LinkedInIcon from "./svg/24/LinkedInIcon";
import PinterestIcon from "./svg/24/PinterestIcon";
import StrikkefasthetIcon from "./svg/24/StrikkefasthetIcon";
import TwitterIcon from "./svg/24/TwitterIcon";
import YoutubeIcon from "./svg/24/YoutubeIcon";
import PlayIcon from "./svg/24/PlayIcon";

export {
  DeliveryBoxIcon,
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  PinterestIcon,
  StrikkefasthetIcon,
  ThicknessIcon,
  TwitterIcon,
  YarnIcon,
  YoutubeIcon,
  PlayIcon,
};
